<div *ngIf="adminService.isAuthenticated()" fxLayout="column" fxFill fxLayoutAlign="start stretch" class="users-container">
  <div fxLayout="column" fxLayoutAlign="space-between stretch"  class="map-card-container">
    <mat-card class="map-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-title fxLayout="row" fxLayoutAlign="start ">
          <div>Geographic Traffic Map</div>
          <div class="click-to-top" fxLayout="row" fxLayoutAlign="start center">
            <img width="20" height="20" src="assets/info.png" />
            <span>Traffic percentage in the last 12 months or last 7 days</span>
          </div>
        </mat-card-title>
        <mat-button-toggle-group name="mapPeriod" aria-label="Map Period" [(value)]="mapPeriod" (change)="mapPeriod = $event.value; updateGeographicMap();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content id="map-svg-container" style="overflow: hidden;">
        <div class="svg-zoom-buttons">
          <button id="svg-zoom-in">+</button>
          <button id="svg-zoom-out">-</button>
        </div>
        <div id="map-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="session-freq-card-container">
    <mat-card class="session-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-title>Session Frequency</mat-card-title>
        <mat-button-toggle-group name="sessionFrequencyPeriod" aria-label="Session Frequency Period" [(value)]="sessionFrequencyPeriod" (change)="sessionFrequencyPeriod = $event.value; updateSessionFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isSessionFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isSessionFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="session-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between stretch" class="tool-card-container">
    <mat-card class="tool-ver-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Tool Versions Frequency</mat-card-title>
        <mat-button-toggle-group name="toolVersionFrequencyPeriod" aria-label="Tool Version Frequency Period" [(value)]="toolVersionFrequencyPeriod" (change)="toolVersionFrequencyPeriod = $event.value; updateToolVersionFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isToolVersionFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isToolVersionFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="tool-ver-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
    <mat-card class="tool-lang-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Tool Language Frequency</mat-card-title>
        <mat-button-toggle-group name="toolLanguageFrequencyPeriod" aria-label="Tool Language Frequency Period" [(value)]="toolLanguageFrequencyPeriod" (change)="toolLanguageFrequencyPeriod = $event.value; updateToolLanguageFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isToolLanguageFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isToolLanguageFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="tool-lang-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
    <mat-card class="browsers-freq-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Browsers Frequency</mat-card-title>
        <mat-button-toggle-group name="browsersFrequencyPeriod" aria-label="Browsers Frequency Period" [(value)]="browsersFrequencyPeriod" (change)="browsersFrequencyPeriod = $event.value; updateBrowsersFrequencyChart();">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isBrowsersFrequencyChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isBrowsersFrequencyChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div id="browsers-freq-chart-svg"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>